import React from 'react'
import { useNavigate } from 'react-router-dom'
import { Typography, Button } from 'antd'
import { useTranslation } from 'react-i18next'

import './NotFound.css'

const { Title, Paragraph } = Typography

const NotFound: React.FC = () => {
    const { t } = useTranslation()
    const navigate = useNavigate()

    return (
        <div className="not-found-container">
            <div className="not-found-content">
                <div className="not-found-number">404</div>
                <Title className="title" level={1}>
                    {t('notFound.title')}
                </Title>
                <Paragraph className="paragraph">
                    {t('notFound.description')}
                </Paragraph>

                <Button
                    type="primary"
                    className="home-button"
                    onClick={() => navigate('/')}
                >
                    {t('notFound.backToHome')}
                </Button>
            </div>
        </div>
    )
}

export default NotFound
